import * as React from "react";
import ProductImage, {
  ImageState
} from "~/components/ProductImageModeration/ProductImage";
import { IAliExpressPullingImage } from "~/graphql/queries/aliexpress/optionPendingModeration";
import styled from "~/styled";

interface IProps {
  images: IAliExpressPullingImage[];
  mainImageId: string | null;
  discardImageIds: string[];

  onImageSelect: (imageId: string) => any;
  onImageDiscard: (imageId: string, bulk?: boolean) => any;
}

const Grid = styled.div`
  display: grid;
  grid-gap: 12px;
  grid-template-columns: repeat(auto-fill, 300px);
`;

export default class ProductImageList extends React.Component<IProps> {
  public render() {
    const {
      images,
      mainImageId,
      discardImageIds,
      onImageDiscard,
      onImageSelect
    } = this.props;

    return (
      <Grid onContextMenu={this.ignoreContextMenu}>
        {images.map((image, index) => {
          const state =
            image.id === mainImageId
              ? ImageState.MAIN_PRODUCT_IMAGE
              : discardImageIds.includes(image.id)
                ? ImageState.DELETE
                : ImageState.DEFAULT;

          return (
            <ProductImage
              key={image.id}
              index={index}
              image={image}
              state={state}
              onDiscard={onImageDiscard}
              onSelect={onImageSelect}
            />
          );
        })}
      </Grid>
    );
  }

  public ignoreContextMenu = (event: React.MouseEvent<HTMLDivElement>) =>
    event.preventDefault();
}



// WEBPACK FOOTER //
// ./src/components/ProductImageModeration/ProductImageList.tsx